export function call(fnc, ...args) {
    if (fnc && typeof fnc === 'function') {
        // eslint-disable-next-line prefer-spread
        return fnc.apply(null, args);
    }
    return null;
}
export function noop(..._) {
    /* void */
}
